"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = require("react");
var _Help = require("../Help");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _KeyboardArrowDown = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowDown"));
var _KeyboardArrowUp = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowUp"));
var _styles = require("@mui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "subTitle", "children", "isCollapsable", "initialOpen", "action", "style", "className", "required", "fullHeight", "error", "disableSubTitleTypography", "paddingTop", "prompt"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'Section';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      margin: '-1px 0 0px !important',
      padding: '0',
      paddingBottom: '16px',
      paddingTop: function paddingTop(_ref) {
        var _paddingTop = _ref.paddingTop;
        return _paddingTop;
      },
      display: 'flex',
      flexDirection: 'column',
      borderTop: function borderTop(_ref2) {
        var withDividers = _ref2.withDividers;
        return withDividers ? "1px solid ".concat(theme.palette.dividerHex) : null;
      },
      borderBottom: function borderBottom(_ref3) {
        var withDividers = _ref3.withDividers;
        return withDividers ? "1px solid ".concat(theme.palette.dividerHex) : null;
      }
    },
    sectionTitleContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: function paddingBottom(_ref4) {
        var open = _ref4.open;
        return open ? 16 : 0;
      }
    },
    toggler: {
      marginLeft: '8px'
    },
    action: {},
    actions: {
      display: 'flex'
    },
    sectionContent: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    fullHeight: {
      flexGrow: 1
    }
  };
}, {
  name: 'GgSection'
});
var Section = function Section(_ref5) {
  var title = _ref5.title,
    subTitle = _ref5.subTitle,
    children = _ref5.children,
    _ref5$isCollapsable = _ref5.isCollapsable,
    isCollapsable = _ref5$isCollapsable === void 0 ? false : _ref5$isCollapsable,
    _ref5$initialOpen = _ref5.initialOpen,
    initialOpen = _ref5$initialOpen === void 0 ? true : _ref5$initialOpen,
    _ref5$action = _ref5.action,
    action = _ref5$action === void 0 ? null : _ref5$action,
    style = _ref5.style,
    className = _ref5.className,
    required = _ref5.required,
    fullHeight = _ref5.fullHeight,
    error = _ref5.error,
    disableSubTitleTypography = _ref5.disableSubTitleTypography,
    _ref5$paddingTop = _ref5.paddingTop,
    paddingTop = _ref5$paddingTop === void 0 ? '16px' : _ref5$paddingTop,
    prompt = _ref5.prompt,
    props = _objectWithoutProperties(_ref5, _excluded);
  var _useState = (0, _react.useState)(initialOpen),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var classes = useStyles({
    withDividers: isCollapsable,
    open: open,
    paddingTop: paddingTop
  });
  var hasTitle = title !== undefined || subTitle !== undefined;
  (0, _react.useEffect)(function () {
    if (open !== initialOpen) {
      setOpen(initialOpen);
    }
  }, [initialOpen]);
  (0, _react.useEffect)(function () {
    return function () {
      if (isCollapsable) {
        // isCollapsable changed from true to false
        setOpen(false);
      }
    };
  }, [isCollapsable]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _clsx2["default"])(classes.root, className, _defineProperty({}, classes.fullHeight, fullHeight)),
    style: style,
    "data-cy": dataCy,
    "data-cy-label": title,
    "data-cy-state": open ? 'open' : 'close'
  }, props), {}, {
    children: [hasTitle ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: classes.sectionTitleContainer,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography["default"], {
          variant: 'subtitle1',
          "data-cy-role": 'sectionTitle',
          sx: {
            fontWeight: 500
          },
          children: [title, " ", required ? ' *' : '', prompt ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Help.Help, {
            children: prompt
          }) : null]
        }), subTitle ? disableSubTitleTypography ? subTitle : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
          variant: 'caption',
          color: error ? 'error' : 'textSecondary',
          display: 'block',
          children: subTitle
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: classes.actions,
        children: [action && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: classes.action,
          children: action
        }), isCollapsable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
          onClick: function onClick() {
            setOpen(function (prev) {
              return !prev;
            });
          },
          "data-cy-action": 'toggle',
          size: 'large',
          className: classes.toggler,
          children: open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_KeyboardArrowUp["default"], {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_KeyboardArrowDown["default"], {})
        })]
      })]
    }) : null, open && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.sectionContent,
      children: children
    })]
  }));
};
Section.propTypes = {
  isCollapsable: _propTypes["default"].bool,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].func]),
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  initialOpen: _propTypes["default"].bool
};
var _default = exports["default"] = Section;